<template>
  <div class="minwidth w100 mw100" style="position: relative;background-color: #151419;color: #fff;">
    <tabbar></tabbar>

    <!-- <carousel2></carousel2> -->

    <div class="pcScreen">
      <div
        style="width: 70%;margin: 0 auto;background-color: #25242A;position: relative;display: flex;justify-content: flex-end;margin-top: 1%;">
        <div
          style="color: #C5B497;width: 55%;position: absolute;top: 50%;left: 5%;transform: translateY(-50%);z-index: 9;">
          <div style="border-left: max(3px,0.3vw) solid #C5B497;padding-left: 2%;font-size: max(17px,1.7vw);font-weight: 500;">
            关于泺阳
          </div>
          <div style="font-size: max(9px,0.9vw);margin-top: 3%;line-height: 2;text-align: justify;">
            上海泺阳网络科技有限公司成立于2021年，是一家专注于移动互联网领域的科技企业。公司立足运营商生态体系，致力于通过技术创新与资源整合，为通信运营商提供专业化、全链路的解决方案与服务支持。<br>
            依托头部互联网平台资源优势，公司聚焦权益运营、智能营销及数字化能力构建三大领域，为通信运营商提供全方位赋能服务。通过与国内头部互联网媒体平台及主流APP建立长期战略合作伙伴关系，公司持续为省、市级运营商客户提供创新产品的互联网运营与精准推广服务。<br>
            以解决运营商公众营销与全客营销痛点为核心目标，上海泺阳网络科技有限公司始终秉持专业、创新的服务理念，矢志成为互联网通信服务领域的标杆企业。<br>
          </div>
        </div>
        <div style="width: 50%;position: relative;z-index: 2;">
          <img style="width: 100%;height: auto;" :src="require('../../public/img/partner/partner_banner1.png')" alt="">
        </div>
      </div>
      <div style="width: 70%;margin: 0 auto;margin-bottom: 5%;">
        <img style="width: 100%;height: auto;display: block;" :src="require('../../public/img/main/main_subbanner.png')"
          alt="">
      </div>

      <div
        style="width: 70%;margin: 0 auto;display: flex;justify-content: flex-end;color: #C5B497;position: relative;padding-top: 3%;margin-bottom: 8%;">
        <div style="width: 90%;background-color: #25242A;display: flex;justify-content: flex-end;border-radius: 0.2em;">
          <div style="width: 75%;padding: 3% 0;margin-right: 5%;text-align: justify;">
            <div style="font-size: max(11px,1.1vw);line-height: 2;">
               上海泺阳科技科技有限公司总部位于上海，并在全国范围内与头部互联网媒体及知名应用建立了深度合作关系。公司团队聚集了国内优秀的互联网产品、研发等专业人才，积累了丰富的企业用户行业服务经验和通信产品推广运营经验。团队凭借对行业痛点的敏锐洞察力，不断探索行业数字化转型的新路径，助力企业用户实现更高效的商业增长。 
            </div>
          </div>
        </div>
        <div style="position: absolute;left: 0;top: 0;width: 25%;">
          <div style="position: relative;">
            <img style="width: 100%;height: auto;display: block;border-radius: 0.2em;"
              :src="require('../../public/img/partner/partner_culture1.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;top: 55%;transform: translateY(-50%);width: 100%;height: 35%;color: #C5B497;display: flex;align-items: center;justify-content: center;">
              <div style="width: 60%;">
                <div style="font-size: max(20px,2vw);font-weight: 500;text-align: center;">
                  团队介绍
                </div>
                <div style="font-size: max(8px,0.8vw);font-weight: 500;margin-top: 3%;text-align: center;">
                  TEAM INTRODUCTION
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style="width: 70%;margin: 0 auto;display: flex;justify-content: flex-start;color: #C5B497;position: relative;padding-top: 3%;margin-bottom: 8%;">
        <div style="width: 90%;background-color: #25242A;display: flex;justify-content: flex-start;border-radius: 0.2em;">
          <div style="width: 75%;padding: 3% 0;margin-left: 5%;text-align: justify;">
            <div style="font-size: max(12px,1.2vw);line-height: 2;">
              依托头部互联网平台资源优势，公司聚焦权益运营、智能营销及数字化能力构建三大领域，为通信运营商提供全方位赋能服务。通过与国内头部互联网媒体平台及主流APP建立长期战略合作伙伴关系，公司持续为省、市级运营商客户提供创新产品的互联网运营与精准推广服务。
            </div>
          </div>
        </div>
        <div style="position: absolute;right: 0;top: 0;width: 25%;">
          <div style="position: relative;">
            <img style="width: 100%;height: auto;display: block;border-radius: 0.2em;"
              :src="require('../../public/img/partner/partner_culture1.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;top: 55%;transform: translateY(-50%);width: 100%;height: 35%;color: #C5B497;display: flex;align-items: center;justify-content: center;">
              <div style="width: 60%;">
                <div style="font-size: max(20px,2vw);font-weight: 500;text-align: center;">
                  核心业务
                </div>
                <div style="font-size: max(8px,0.8vw);font-weight: 500;margin-top: 3%;text-align: center;">
                  CORE BUSINESS
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style="width: 70%;margin: 0 auto;display: flex;justify-content: flex-end;color: #C5B497;position: relative;padding-top: 2%;margin-bottom: 8%;">
        <div style="width: 90%;background-color: #25242A;display: flex;justify-content: flex-end;border-radius: 0.2em;">
          <div style="width: 75%;padding: 3% 0;margin-right: 5%;text-align: justify;">
            <div style="font-size: max(12px,1.2vw);line-height: 2;height: 9em;">
              以解决运营商公众营销与全客营销痛点为核心目标，上海泺阳网络科技有限公司始终秉持专业、创新的服务理念，矢志成为互联网通信服务领域的标杆企业。
            </div>
          </div>
        </div>
        <div style="position: absolute;left: 0;top: 0;width: 25%;">
          <div style="position: relative;">
            <img style="width: 100%;height: auto;display: block;border-radius: 0.2em;"
              :src="require('../../public/img/partner/partner_culture1.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;top: 55%;transform: translateY(-50%);width: 100%;height: 35%;color: #C5B497;display: flex;align-items: center;justify-content: center;">
              <div style="width: 60%;">
                <div style="font-size: max(20px,2vw);font-weight: 500;text-align: center;">
                  公司理念
                </div>
                <div style="font-size: max(8px,0.8vw);font-weight: 500;margin-top: 3%;text-align: center;">
                  COMPANY PHILOSOPHY
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="width: 70%;margin: 0 auto;margin-bottom: 5%;">
        <div style="font-size: max(25px,2.5vw);font-weight: bold;letter-spacing: 0.1em;">合作伙伴</div>
        <div style="font-size: max(10px,1vw);font-weight: bold;margin-top: 1%;">CORPORATE CULTURE</div>
        <div style="width: 100%;margin-top: 3%;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/partner/partner_partner.png')" alt="">
        </div>
      </div>

      <div style="width: 70%;margin: 0 auto;margin-bottom: 5%;">
        <div style="font-size: max(25px,2.5vw);font-weight: bold;letter-spacing: 0.1em;">企业愿景</div>
        <div style="font-size: max(10px,1vw);font-weight: bold;margin-top: 1%;">CORPORATE CULTURE</div>
        <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;margin-top: 3%;">
          <div style="width: 28%;position: relative;">
            <img style="width: 100%;height: auto;display: block;"
              :src="require('../../public/img/main/main_culture1.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 45%;">
              <div style="font-size: max(15px,1.5vw);font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
                企业文化
              </div>
              <div style="font-size: max(9px,0.9vw);width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
                创新驱动，客户至上。<br>
                团队协作，共同成长。
              </div>
            </div>
          </div>
          <div style="width: 28%;position: relative;">
            <img style="width: 100%;height: auto;display: block;"
              :src="require('../../public/img/main/main_culture2.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 45%;">
              <div style="font-size: max(15px,1.5vw);font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
                企业愿景
              </div>
              <div style="font-size: max(9px,0.9vw);width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
                成为运营商行业数字化转型的引领者，<br>
                打造移动互联网信息服务的领先品牌。
              </div>
            </div>
          </div>
          <div style="width: 28%;position: relative;">
            <img style="width: 100%;height: auto;display: block;"
              :src="require('../../public/img/main/main_culture3.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 45%;">
              <div style="font-size: max(15px,1.5vw);font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
                企业价值观
              </div>
              <div style="font-size: max(9px,0.9vw);width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
                客户第一：关注需求，创造价值。 创新为本：技术领先，持续突破。 协作共赢：团队合作，共创未来。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mobileScreen">
      <div
        style="width: 100%;margin: 0 auto;background-color: #25242A;position: relative;display: flex;justify-content: flex-end;margin-top: 1%;">
        <div
          style="color: #C5B497;width: 55%;position: absolute;top: 50%;left: 5%;transform: translateY(-50%);z-index: 9;">
          <div style="border-left: 0.4% solid #C5B497;padding-left: 2%;font-size: max(15px,1.5vw);font-weight: 500;">
            关于泺阳
          </div>
          <div style="font-size: max(8px,0.8vw);margin-top: 3%;line-height: 2;text-align: justify;">
            上海泺阳网络科技有限公司成立于2021年，是一家专注于移动互联网领域的科技企业。公司立足运营商生态体系，致力于通过技术创新与资源整合，为通信运营商提供专业化、全链路的解决方案与服务支持。<br>
          </div>
        </div>
        <div style="width: 50%;position: relative;z-index: 2;">
          <img style="width: 100%;height: auto;" :src="require('../../public/img/partner/partner_banner1.png')" alt="">
        </div>
      </div>
      <div style="width: 100%;margin: 0 auto;margin-bottom: 5%;">
        <img style="width: 100%;height: auto;display: block;" :src="require('../../public/img/main/main_subbanner.png')"
          alt="">
      </div>

      <div style="width: 100%;height: 30%;color: #C5B497;display: flex;align-items: center;justify-content: center;">
        <div style="width: 60%;">
          <div style="font-size: max(13px,1.3vw);font-weight: 500;text-align: center;">
            团队介绍
          </div>
          <div style="font-size: max(6px,0.6vw);font-weight: 500;margin-top: 3%;text-align: center;">
            TEAM INTRODUCTION
          </div>
        </div>
      </div>
      <div
        style="width: 95%;margin: 0 auto;display: flex;justify-content: center;color: #C5B497;position: relative;padding-top: 2%;margin-bottom: 5%;">
        <div style="width: 100%;background-color: #25242A;display: flex;justify-content: center;border-radius: 0.2em;">
          <div style="width: 90%;padding: 3% 0;text-align: justify;">
            <div style="font-size: max(8px,0.8vw);line-height: 2;">
              上海泺阳科技科技有限公司总部位于上海，并在全国范围内与头部互联网媒体及知名应用建立了深度合作关系。公司团队聚集了国内优秀的互联网产品、研发等专业人才，积累了丰富的企业用户行业服务经验和通信产品推广运营经验。团队凭借对行业痛点的敏锐洞察力，不断探索行业数字化转型的新路径，助力企业用户实现更高效的商业增长。
            </div>
          </div>
        </div>
      </div>

      <div style="width: 100%;height: 30%;color: #C5B497;display: flex;align-items: center;justify-content: center;">
        <div style="width: 60%;">
          <div style="font-size: max(13px,1.3vw);font-weight: 500;text-align: center;">
            核心业务
          </div>
          <div style="font-size: max(6px,0.6vw);font-weight: 500;margin-top: 3%;text-align: center;">
            CORE BUSINESS
          </div>
        </div>
      </div>
      <div
        style="width: 95%;margin: 0 auto;display: flex;justify-content: center;color: #C5B497;position: relative;padding-top: 2%;margin-bottom: 5%;">
        <div style="width: 100%;background-color: #25242A;display: flex;justify-content: center;border-radius: 0.2em;">
          <div style="width: 90%;padding: 3% 0;text-align: justify;">
            <div style="font-size: max(8px,0.8vw);line-height: 2;">
              依托头部互联网平台资源优势，公司聚焦权益运营、智能营销及数字化能力构建三大领域，为通信运营商提供全方位赋能服务。通过与国内头部互联网媒体平台及主流APP建立长期战略合作伙伴关系，公司持续为省、市级运营商客户提供创新产品的互联网运营与精准推广服务。
            </div>
          </div>
        </div>
      </div>

      <div style="width: 100%;height: 30%;color: #C5B497;display: flex;align-items: center;justify-content: center;">
        <div style="width: 60%;">
          <div style="font-size: max(13px,1.3vw);font-weight: 500;text-align: center;">
            公司理念
          </div>
          <div style="font-size: max(6px,0.6vw);font-weight: 500;margin-top: 3%;text-align: center;">
            COMPANY PHILOSOPHY
          </div>
        </div>
      </div>
      <div
        style="width: 95%;margin: 0 auto;display: flex;justify-content: center;color: #C5B497;position: relative;padding-top: 2%;margin-bottom: 5%;">
        <div style="width: 100%;background-color: #25242A;display: flex;justify-content: center;border-radius: 0.2em;">
          <div style="width: 90%;padding: 3% 0;text-align: justify;">
            <div style="font-size: max(8px,0.8vw);line-height: 2;">
              以解决运营商公众营销与全客营销痛点为核心目标，上海泺阳网络科技有限公司始终秉持专业、创新的服务理念，矢志成为互联网通信服务领域的标杆企业。
            </div>
          </div>
        </div>
      </div>

      <div style="width: 95%;margin: 0 auto;margin-bottom: 5%;">
        <div style="font-size: 3.5vw;font-weight: bold;letter-spacing: 0.1em;width: 95%;margin: 0 auto;">合作伙伴</div>
        <div style="font-size: 2vw;font-weight: bold;margin-top: 0.5%;width: 95%;margin: 0 auto;">CORPORATE CULTURE</div>
        <div style="width: 95%;margin: 0 auto;margin-top: 3%;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/partner/partner_partner_1.png')" alt="">
        </div>
      </div>

      <div style="width: 95%;margin: 0 auto;margin-bottom: 3%;">
        <div style="font-size: 3.5vw;font-weight: bold;letter-spacing: 0.1em;width: 95%;margin: 0 auto;">企业愿景</div>
        <div style="font-size: 2vw;font-weight: bold;margin-top: 0.5%;width: 95%;margin: 0 auto;">CORPORATE CULTURE</div>
        <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;margin-top: 3%;">
          <div style="width: 30%;margin: 0 auto;position: relative;">
            <img style="width: 100%;height: auto;display: block;"
              :src="require('../../public/img/main/main_culture1.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 55%;">
              <div style="font-size: 2.8vw;font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
                企业文化
              </div>
              <div style="font-size: 1.5vw;width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
                创新驱动，客户至上。<br>
                团队协作，共同成长。
              </div>
            </div>
          </div>
          <div style="width: 30%;margin: 0 auto;position: relative;">
            <img style="width: 100%;height: auto;display: block;"
              :src="require('../../public/img/main/main_culture2.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 55%;">
              <div style="font-size: 2.8vw;font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
                企业愿景
              </div>
              <div style="font-size: 1.5vw;width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
                成为运营商行业数字化转型的引领者，<br>
                打造移动互联网信息服务的领先品牌。
              </div>
            </div>
          </div>
          <div style="width: 30%;margin: 0 auto;position: relative;">
            <img style="width: 100%;height: auto;display: block;"
              :src="require('../../public/img/main/main_culture3.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 55%;">
              <div style="font-size: 2.8vw;font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
                企业价值观
              </div>
              <div style="font-size: 1.5vw;width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
                客户第一：关注需求，创造价值。创新为本：技术领先，持续突破。协作共赢：团队合作，共创未来。
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <bottom></bottom>

    <!-- <customerservice></customerservice> -->

  </div>
</template>

<script>
  export default {
    data() {
      return {
        typeIndex: 0
      };
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .w100 {
    width: 100%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .pcScreen {
    display: block;
  }

  .mobileScreen {
    display: none;
  }

  @media screen and (max-width: 750px) {
    .pcScreen {
      display: none;
    }

    .mobileScreen {
      display: block;
    }

    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }
  }
</style>